<template>
  <div>
    <!-- 下拉单选控件 -->
    <el-select style="width:100%"
      :size="size"
      v-model="showSelectOrg"
      v-selectDisableClose
      placeholder="请选择"
      :disabled="selectDisabled"
      multiple
      filterable
      :filter-method="filterOrg"
      :collapse-tags="collapseTags"
      :clearable="clearable"
      @clear="clearSelect"
      @visible-change="vChange"
      @remove-tag="removeTag"
    >
      <el-option
        :value="showSelectOrg"
        style="height: auto"
      >
        <!-- <el-input
        placeholder="输入关键字进行过滤"
        v-model="filterOrg"
      >
      </el-input> -->
        <el-tree
          class="filter-tree"
          :data="orgTree"
          v-loading="loading"
          show-checkbox
          check-strictly
          :default-expanded-keys="expandKeys"
          node-key="id"
          ref="tree"
          highlight-current
          :check-on-click-node="checkOnClickNode"
          :props="defaultProps"
          :default-checked-keys="initValue"
          @check-change="handleCheckChange"
          :filter-node-method="filterNode"
        ></el-tree>
      </el-option>
    </el-select>

  </div>
</template>
<script>
export default {
  data() {
    return {
      checkOnClickNode: true,
      showSelectOrg: "",
      selectOrgIds: "",
      orgTree: [],
      loading: true,
      defaultProps: {
        children: "children",
        label: "name",
      },
      options: [],
    };
  },
  props: {
    parentDisabled:false,
    collapseTags: {
      type: Boolean,
      default() {
        return false
      }
    },
    clearable: {
      type: Boolean,
      default() {
        return false
      }
    },
    parentId:{
      type: String,
      default : '50020020'
    },
    initValue: Array,
    expandKeys: {
      type:Array, //50020020 二级节点展开  50652940 审计监察部节点展开
      default:['50020020']
    },
    multipleSelect: Boolean,
    selectDisabled: Boolean,
    indexSelect:Number,
    size: String,
  },
  directives: {
    selectDisableClose: {
      componentUpdated: function (el, bindings, vnode) {
        const dealStyle = function (tags) {
          tags.forEach((el, index) => {
            if (![el.classList].includes("select-tag-close-none")) {
              el.classList.add("select-tag-close-none");
            }
          });
        };
        setTimeout(() => {
          const tagTemp = el.querySelectorAll(".el-tag__close");
          dealStyle(tagTemp);
        });
      },
    },
  },
  created() {
      this.initOrgTree();
  },
  mounted() {
    this.getOrgTreeData();
  },
  methods: {
    vChange(){
      // this.getOrgTreeData();
    },
    changeValue(){
      if(!this.orgTree){
          this.getOrgTreeData();
      }      
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    getOrgTreeData() {
      this.loading = true;
      this.$axios
        .get("/api/orgPerson/v0.1/org/getOrgTreeList", {
          params: {
            parentId: this.parentId,
          },
        })
        .then((res) => {
          var js = res.data;
          if (js.errcode == 0) {
            if(this.parentDisabled){
              js.data = js.data.map(item=>{
                item.disabled = true
                return item
              })
            }
            this.orgTree = js.data;
            this.loading = false;
          } else {
            this.loading = true;
            this.$message({
              showClose: true,
              message: js.errmsg,
              type: "error",
            });

          }
        });
    },
    initOrgTree() {

     if (!this.initValue || this.initValue.length == 0) {
        this.showSelectOrg = [];
        this.selectOrgIds = [];
        return;
      }

      this.loading = true;
      this.$axios
        .get("/api/orgPerson/v0.1/org/getOrgList", {
          params: {
            orgGuids: this.initValue.join(","),
          },
        })
        .then((res) => {
          var js = res.data;
          if (js.errcode == 0) {
            let arrLabel = [];
            let arrValue = [];

            js.data.forEach((item) => {
              arrLabel.push(item.name);
              arrValue.push(item.id);
            });
            this.showSelectOrg = arrLabel;
            this.selectOrgIds = arrValue;

            this.loading = false;
          } else {
            this.loading = false;
            this.$message({
              showClose: true,
              message: js.errmsg,
              type: "error",
            });
          }
        });
    },
    removeTag(v){
      let res = this.$refs.tree.getCheckedNodes(false, true);
      res.forEach(item=>{
        if(v==item.name){
          this.$refs.tree.setChecked(item,false);
        }
      })
      
    },
    // tree select
    handleCheckChange(data, checked, node) {
      let res = this.$refs.tree.getCheckedNodes(false, true); //true，1. 是否只是叶子节点 2.选择的时候不包含父节点）
      let arrLabel = [];
      let arrValue = [];
      if (checked && !this.multipleSelect) {
        this.$refs.tree.setCheckedNodes([data]);
        arrLabel.push(data.name);
        arrValue.push(data.id);
      } else {
        res.forEach((item) => {
          arrLabel.push(item.name);
          arrValue.push(item.id);
        });
      }

      this.showSelectOrg = arrLabel;
      this.selectOrgIds = arrValue;
      //this.$emit("getSelectValue", this.selectOrgIds);
      if(this.indexSelect || this.indexSelect==0){
          this.$emit("getSelectValue", this.selectOrgIds+"-"+this.indexSelect);
           this.$emit("getSelectLabel", this.showSelectOrg);
      }else{
          this.$emit("getSelectValue", this.selectOrgIds);
          this.$emit("getSelectLabel", this.showSelectOrg);
      }
    },
    filterOrg(val) {
      this.$refs.tree.filter(val);
    },
    clearSelect(){
      this.showSelectOrg = [];
      this.selectOrgIds = [];
      this.$refs.tree.setCheckedNodes([]);
    }
  },
  watch: {
    initValue() {
      this.initOrgTree();
    },

  },
};
</script>
<style scoped>
.el-select-dropdown__item {
  padding: 0 0 0 0;
}
.select-tag-close-none {
  display: none;
}
</style>